import {api} from '@/lib/api';

// ACK only after this exact internal notification was fetched in the visible app.
// Closing, changing Studio, a failed fetch or a suspended tab leaves push enabled.
export async function acknowledgeForegroundInquiry(signal, relationshipId, live = () => true) {
  const visible = () => live() && document.visibilityState === 'visible';
  if (!visible() || !signal.token || !signal.notification_id) return false;
  try {
    const item = await api.get(`/client/relationships/${encodeURIComponent(relationshipId)}/notifications/${encodeURIComponent(signal.notification_id)}`);
    if (!visible() || item?.id !== signal.notification_id) return false;
    window.dispatchEvent(new CustomEvent('tps:data-changed', {detail: {source: 'inquiry-foreground'}}));
    const result = await api.post('/realtime/client-foreground-ack', {token: signal.token, relationship_id: relationshipId});
    return Boolean(result?.acknowledged);
  } catch { return false; }
}
